export const PAGES_PAGE_SIZE = 10;

export function pageOffset(page: number): number {
  return (page - 1) * PAGES_PAGE_SIZE;
}
